<template>
  <div>
    <div class='oilInfo'>
      <div class='oilBaseInfo' :style='`width:${width-270}px`'>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="选择层">
            <el-select placeholder="选择层"  v-model='oilActiveLayer'>
              <el-option :label="item.name" :value="item.ind"  v-for='item in oilLayerList' :key='item.ind'></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="primary" class='print' plain @click='print'>打印<i class="el-icon-printer el-icon--right"></i></el-button>
        <el-button type="primary" class="exportExcel" plain @click="exportExcel">导出<i class="el-icon-document el-icon--right"></i></el-button>
        <div class='oilPartWrap'>
          <div class='oilPart'>
            <div class='oilNameInfo'><span>油&nbsp;&nbsp;量：</span><span>{{oilData.percentage<0?0:oilData.percentage}}</span>%</div>
            <div class='oilNameInfo'><span>油位高：</span><span>{{oilData.bitHeight<0?0:oilData.bitHeight}}</span> m</div>
          </div>
          <div class='oilPart oilTempPart'>
            <div class='oilTempInfo'>
              <span class='oilTempValue'>{{oilData.tempAve}}°C</span>
              <span>平均温度</span>
            </div>
            <div class='oilTempInfo'>
              <span class='oilTempValue'>{{oilData.tempMax}}°C</span>
              <span>最高温度</span>
            </div>
            <div class='oilTempInfo'>
              <span class='oilTempValue'>{{oilData.tempMin}}°C</span>
              <span>最低温度</span>
            </div>
          </div>
        </div>
      </div>
      <div class='secondView oil3DShow' :style="`height:${height-120}px;width:${width-270}px`">
        <div class='Show3DWrap'>
          <div class='oilTable'>
            <div class='oilLayer'>
              <div>层</div>
              <div>温度(℃)</div>
            </div>
            <div v-for='(item,index) in oilData.temps' :key='index'>
              <div class='oilLayer' v-if='index==0'>
                <div>罐温</div>
                <div>{{item}}</div>
              </div>
              <div class='oilLayer' v-else>
                <div>第{{index}}层</div>
                <div>{{item}}</div>
              </div>
            </div>
          </div>
          <div class='updateCjTime'>采集时间：{{oilData.currTime}}<el-button type="primary" style='margin-left:20px' @click="getRadar">采集油情</el-button></div>
          <div class="oilControlWheel">
            <div class="oilDirectionWrap">
              <div class="oildirection oildirectionTop" @mousedown="setDirectionTop" @mouseup="stopDirectionTop">
                <div class="oildirectionImg"></div>
              </div>
              <div class="oildirection oildirectionLeft" @mousedown="setDirectionLeft" @mouseup="stopDirectionLeft">
                <div class="oildirectionImg"></div>
              </div>
              <div class="oildirection oildirectionRight" @mousedown="setDirectionRight" @mouseup='stopDirectionRight'>
                <div class="oildirectionImg"></div>
              </div>
              <div class="oildirection oildirectionBottom" @mousedown="setDirectionBottom" @mouseup='stopDirectionBottom'>
                <div class="oildirectionImg"></div>
              </div>
              <div class="oildirection oildirectionCenter" @click="setReset">
                <div class="oildirectionCenterImg">复位</div>
              </div>
            </div>
          </div>
          <div class="oilCard">
            <div class="oilCardItem">数据卡片</div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油脂品种</span>
              <span class="oilCardWrap">{{oilData.foodFariety}}</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油脂性质</span>
              <span class="oilCardWrap">{{oilData.foodType}}</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油脂等级</span>
              <span class="oilCardWrap">{{oilData.foodLevel}}</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油脂产地</span>
              <span class="oilCardWrap">{{oilData.origin}}</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">雷达高度</span>
              <span class="oilCardWrap">{{oilData.wareHeight}} m</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油罐体积</span>
              <span class="oilCardWrap">{{oilData.wareVolume}} m³</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">油罐高度</span>
              <span class="oilCardWrap">{{oilData.height}} m</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">实际储量</span>
              <span class="oilCardWrap">{{oilData.wareHouse.storageReal}} kg</span>
            </div>
            <div class="oilCardItem">
              <span class="oilCardTitle">保管员</span>
              <span class="oilCardWrap">{{oilData.custodian}}</span>
            </div>
          </div>
          <div class='oilWare3DWrap' draggable="false" :style='`transform:rotateZ(${leavalY}deg) rotateX(${leavalX}deg);`' @mousedown="startDrag($event)">
            <div class="oilWall" v-for='index in 36' :key='index' :style='`transform:rotateY(${index*5}deg);`'></div>
            <div class="oilHeight" v-for='ind in 36' :key='`oilHeight${ind}`' v-if='oilData.percentage>0' :style='`height:${oilData.percentage*400/100}px;transform:rotateY(${ind*5+2.5}deg) translateY(${400-oilData.percentage*400/100}px);;`'></div>
            <div class="oilBottom" :style='`transform: rotateX(90deg) translateZ(${-150+index}px);`' v-for='index in 5' :key='`index${index}`'></div>
            <div class="oilBottom oilTop" style='transform: rotateX(90deg) translateZ(250px);'></div>
            <div class="oilBottom oilHeightTop" :style='`transform: rotateX(90deg) translateZ(${250-(400-400*oilData.percentage/100)}px);`' v-if='oilData.percentage>0'></div>
            <div class='oilBottom oilDataShow' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+index)}px);`' v-for='(item,index) in oilData.temps' :key='`silo${index}`' v-if='oilActiveLayer==0||oilActiveLayer==(index+1)'>
              <div class='oilDataShowWarp'>
                <div class='oilPointWrap'>
                  <div class="oilPoint">
                    <div>{{item}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==1?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5)-ind}px);`' v-for='ind in 5' :key='`bot1${ind}`' v-if='oilData.layerNum>=1'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==2?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+1)-ind}px);`' v-for='ind in 5' :key='`bot2${ind}`' v-if='oilData.layerNum>=2'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==3?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+2)-ind}px);`' v-for='ind in 5' :key='`bot3${ind}`' v-if='oilData.layerNum>=3'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==4?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+3)-ind}px);`' v-for='ind in 5' :key='`bot4${ind}`' v-if='oilData.layerNum>=4'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==5?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+4)-ind}px);`' v-for='ind in 5' :key='`bot5${ind}`' v-if='oilData.layerNum>=5'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==6?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+5)-ind}px);`' v-for='ind in 5' :key='`bot6${ind}`' v-if='oilData.layerNum>=6'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==7?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+6)-ind}px);`' v-for='ind in 5' :key='`bot7${ind}`' v-if='oilData.layerNum>=7'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==8?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+7)-ind}px);`' v-for='ind in 5' :key='`bot8${ind}`' v-if='oilData.layerNum>=8'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==9?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+8)-ind}px);`' v-for='ind in 5' :key='`bot9${ind}`' v-if='oilData.layerNum>=9'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==10?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+9)-ind}px);`' v-for='ind in 5' :key='`bot10${ind}`' v-if='oilData.layerNum>=10'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==11?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+10)-ind}px);`' v-for='ind in 5' :key='`bot11${ind}`' v-if='oilData.layerNum>=11'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==12?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+11)-ind}px);`' v-for='ind in 5' :key='`bot12${ind}`' v-if='oilData.layerNum>=12'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==13?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+12)-ind}px);`' v-for='ind in 5' :key='`bot13${ind}`' v-if='oilData.layerNum>=13'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==14?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+13)-ind}px);`' v-for='ind in 5' :key='`bot14${ind}`' v-if='oilData.layerNum>=14'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==15?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+14)-ind}px);`' v-for='ind in 5' :key='`bot15${ind}`' v-if='oilData.layerNum>=15'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==16?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+15)-ind}px);`' v-for='ind in 5' :key='`bot16${ind}`' v-if='oilData.layerNum>=16'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==17?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+16)-ind}px);`' v-for='ind in 5' :key='`bot17${ind}`' v-if='oilData.layerNum>=17'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==18?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+17)-ind}px);`' v-for='ind in 5' :key='`bot18${ind}`' v-if='oilData.layerNum>=18'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==19?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+18)-ind}px);`' v-for='ind in 5' :key='`bot19${ind}`' v-if='oilData.layerNum>=19'></div>
            <div :class='["oilBottom",oilActiveLayer==0||oilActiveLayer==20?"":"isNotOilBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/oilData.layerNum)*(0.5+19)-ind}px);`' v-for='ind in 5' :key='`bot20${ind}`' v-if='oilData.layerNum==20'></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择仓房" 
      :visible.sync="isShowOilCheckbox"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg oilTempBox"'>
      <el-form ref="alloilListInfo" :model="alloilListInfo">
        <div class='dialog-setWrap'>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="checkAllOil">全选</el-checkbox>
          <el-form-item>
            <el-checkbox-group v-model="alloilListInfo.checkedOil" @change='oilChange'>
              <div class='commonItem oilItemsmall' v-for='item in oilList' :key='item.wareId'>
                <el-checkbox :label="item.wareId">{{item.wareName}}
                  <div class="oilImgsmall"></div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item class="previewInfo">
          <el-button type="primary" @click="preview">预览</el-button>
          <el-button @click='isShowOilCheckbox=false'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
import transform from '../../exportExcel.js'
export default {
  props:{
    width:Number,
    height:Number,
    wareId:Number
  },
  data(){
    return{
      oilData:{},
      oilLayerList:[],
      oilActiveLayer:0,
      leavalX:0,
      leavalY:0,
      setoilToptimer:null,
      setoilBottomtimer:null,
      setoilLefttimer:null,
      setoilRighttimer:null,
      upOilInfoTimer:null,
      isShowOilCheckbox:false,
      isIndeterminate:false,
      checkAll:false,
      alloilListInfo:{
        checkedOil:[]
      },
      oilList:[],
      allTotal:0,
      allOilId:[],
      isFirst:true
    }
  },
  watch:{
    wareId(){
      this.isFirst=true;
      this.getOilInfo();
      this.getallOil();
      clearInterval(this.upOilInfoTimer); 
      this.upOilInfoTimer=setInterval(this.getOilInfo,30000);
    }
  },
  created(){
    if(this.wareId){
      this.getOilInfo();
      this.getallOil();
      this.upOilInfoTimer=setInterval(this.getOilInfo,30000);
    }
    
  },
  beforeDestroy() {
    if (this.upOilInfoTimer) {
      clearInterval(this.upOilInfoTimer); 
    }
  },
  methods:{
    getallOil(){
      axios.get('/system/house/getHouseSelect',{params:{type:1}}).then(data=>{
        if(data.data.length>0){
          this.oilList=data.data;
          this.allTotal=data.data.length;
          let arr=[]
          data.data.forEach(item=>{
            arr.push(item.wareId)
          })
          this.allOilId=arr;
        }
      })
    },
    getRadar(){
      axios.get('/system/radar/collectRadar',{params:{wareId:this.wareId}}).then(res=>{
        if(res){

        }
      })
    },
    getOilInfo(){
      axios.get('/system/radar/getRadarByWareId',{params:{wareId:this.wareId}}).then(res=>{
        if(res){
          this.oilData=res.data;
          let layer=res.data.layerNum;
          let layerList=[{name:"全部",ind:0}];
          if(layer==0){
            this.$message({
              message:'油罐未配置，请配置相关信息',
              type:'error',
              duration:1000
            })
            this.oilLayerList=[],
            clearInterval(this.upOilInfoTimer); 
          }else{
            if(this.isFirst){
              for(let i=0;i<layer;i++){
                layerList.push({name:"第 "+(i+1)+" 层",ind:i+1})
              }
              this.oilLayerList=layerList;
              this.isFirst=false;
              this.oilActiveLayer=0
            }
          }
        }
      })
    },
    setDirectionTop(){
      let that=this;
      that.setoilToptimer=setInterval(function(){
        if(that.leavalX<90){
          that.leavalX+=1
        }else{
          that.leavalX=90
        }
      },16.67)
    },
    stopDirectionTop(){
      clearInterval(this.setoilToptimer)
    },
    setDirectionRight(){
      let that=this;
      that.setoilRighttimer=setInterval(function(){
        if(that.leavalY<90){
          that.leavalY+=1
        }else{
          that.leavalY=90
        }
      },16.67)
    },
    stopDirectionRight(){
      clearInterval(this.setoilRighttimer)
    },
    setDirectionLeft(){
      let that=this;
      that.setoilLefttimer=setInterval(function(){
        if(that.leavalY>-90){
          that.leavalY-=1
        }else{
          that.leavalY=-90
        }
      },16.67)
    },
    stopDirectionLeft(){
      clearInterval(this.setoilLefttimer)
    },
    setDirectionBottom(){
      let that=this;
      that.setoilBottomtimer=setInterval(function(){
        if(that.leavalX>-90){
          that.leavalX-=1
        }else{
          that.leavalX=-90
        }
      },16.67)
     
    },
    stopDirectionBottom(){
      clearInterval(this.setoilBottomtimer)
    },
    setReset(){
      this.leavalX=-0;
      this.leavalY=-0
    },
    startDrag($event){
      let that=this;
      // 开始
      let dom=document.querySelector('body');
      dom.style.cursor='move'
      window.onmousemove=function(event){
        if(that.leavalY<-90){
          that.leavalY=-90
        }else if(that.leavalY>90){
          that.leavalY=90
        }else{
          if(that.leavalY==90){
            if(event.movementX<0){
              that.leavalY+=(event.movementX/10)
            }
          }else if(that.leavalY==-90){
            if(event.movementX>0){
              that.leavalY+=(event.movementX/10)
            }
          }else{
            that.leavalY+=(event.movementX/10)
          }
        }
        if(that.leavalX<-90){
          that.leavalX=-90
        }else if(that.leavalX>90){
          that.leavalX=90
        }else{
          if(that.leavalX==90){
            if(event.movementY>0){
              that.leavalX-=(event.movementY/10)
            }
          }else if(that.leavalX==-90){
            if(event.movementY<0){
              that.leavalX-=(event.movementY/10)
            }
          }else{
            that.leavalX-=(event.movementY/10)
          }
        }
      }
      // 停止
      window.onmouseup = function () {
        window.onmousemove = null;
        dom.style.cursor='default'
        return
      }
    },
    print(){
      this.isShowOilCheckbox=true;
      this.alloilListInfo.checkedOil=[];
      this.checkAll=false;
      this.isIndeterminate=false
    },
    checkAllOil(val){
      this.alloilListInfo.checkedOil=val?this.allOilId:[];
      this.isIndeterminate=false
    },
    oilChange(value){
      let checkCount=value.length;
      this.checkAll=checkCount===this.allTotal;
      this.isIndeterminate=checkCount>0&&checkCount<this.allTotal;
    },
    preview(){
      if(this.alloilListInfo.checkedOil.length==0){
        this.$message({
          message:"未选择仓房！",
          type:"error",
          duration:1000
        })
        return
      }
      this.$router.push({name:'preView',params:{wareIds:this.alloilListInfo.checkedOil}})
    },
    exportExcel(){
      transform(this.oilData,this.oilData.wareName+'油情信息',3) 
    },
  }
}
</script>

<style>
.oilBaseInfo{
  display: flex;
  position: absolute;
  left: 30px;
  box-sizing: border-box;
  height:90px;
  justify-content:space-between;
  align-items: flex-end;
}
.oilNameInfo{
  font-size: 14px;
  font-weight: 600;
  color: rgba(0,0,0,0.5);
  width: 170px;
  display: flex;
  align-items: center;
}
.oilNameInfo span{
  display: inline-block
}
.oilNameInfo span:first-child{
  width: 64px;
  text-align: end
}
.oilNameInfo span:last-child{
  height: 30px;
  line-height: 30px;
  width: 70px;
  background: rgba(217, 217, 217, 0.23);
  text-align: end;
  padding: 0 3px;
  box-sizing: border-box;
  font-family: 'ledsolid';
  font-size: 24px;
  color: black;
  margin-right: 5px
}
.oilPartWrap{
  height: 100%;
  width: 475px;
  display: flex;
}
.oilPart{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0;
  box-sizing: border-box;
}
.oilTempPart{
  flex-direction: unset;
}
.oilTempInfo{
  font-size: 14px;
  font-weight: 600;
  color: rgba(0,0,0,0.5);
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.oilTempValue{
  font-size: 24px;
  font-family: 'DINPro-Bold';
  color: #000;
}
.oil3DShow{
  background-color: #F6F7FC;
  overflow: hidden;
}
.Show3DWrap{
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 2000px;
}
.oilWare3DWrap{
  height: 400px;
  width: 500px;
  position: relative;
  transform-style: preserve-3d;
}
.oilWare3DWrap>div{
  position: absolute;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.oilWall{
  height: 400px;
  width: 500px;
  border-left: 1px solid #8d8d8d3b;
  border-right: 1px solid #8d8d8d3b;
}
.oilHeight{
  height:100px;
  width: 500px;
  border-right: 1px solid orange;
  border-left: 1px solid orange
}
.oilBottom{
  border: 1px solid;
  height: 500px;
  width: 500px;
  border-radius: 50%;
  background: #b6bfd3
}
.oilTop{
  border:1px solid rgba(0,0,0,0.1);
  background: #b6bfd317
}
.oilHeightTop{
  border: 1px solid rgba(255, 166, 0, 0.3);
  background: rgba(255, 166, 0, 0.3)
}
.isNotOilBottom{
  background:none;
  border: 1px solid rgba(255, 255, 255, 0.23)
}
.oilDataShow{
  background: #9fc7A1;
  border: none;
}
.oilDataShowWarp{
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.oilPointWrap{
  background-color: rgba(222, 206, 151, 0.53);
  border-radius: 50%;
  height: 250px;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.oilPoint{
  background-color:#2ebf2e;
  height:50px;
  width:50px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.oilControlWheel{
  height: 158px;
  width: 158px;
  position: absolute;
  top: 10px;
  right:10px;
  background-image: url("../../assets/grain/control.png");
  background-size: cover;
  z-index: 1000;
}
.oilDirectionWrap{
  height: 158px;
  width: 158px;
  position: relative;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0,0,0,0.1)
}
.oildirection{
  width: 31px;
  height: 46px;
  position: absolute;
  cursor: pointer;
}
.oildirectionImg{
  width: 31px;
  height: 46px;
  background-image: url("../../assets/grain/direction.png");
  background-size: cover
}
.oildirectionCenterImg{
  width: 50px;
  height: 50px;
  background-image: url("../../assets/grain/center.png");
  background-size: cover;
  text-align: center;
  line-height: 50px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0,0,0,0.5);
  border-radius: 50%;
  box-shadow:inset 0 0 5px rgba(0,0,0,0.2)
}
.oildirectionTop{
  left: 50%;
  margin-left: -15px;
  top: 12px
}
.oildirectionBottom{
  transform: rotate(180deg);
  left: 50%;
  margin-left: -15px;
  bottom: 12px
}
.oildirectionLeft{
  transform: rotate(-90deg);
  top: 50%;
  margin-top: -23px;
  left: 18px;
}
.oildirectionRight{
  transform: rotate(90deg);
  top: 50%;
  margin-top: -23px;
  right: 18px;
}
.oildirectionCenter{
  height: 50px;
  width: 50px;
  left: 50%;
  top: 50%;
  margin-top: -25px;
  margin-left: -25px
}
.oilTable{
  position: absolute;
  top: 4px;
  left: 4px;
  border-top: 1px solid rgba(0,0,0,0.1);
  border-left: 1px solid rgba(0,0,0,0.1)
}
.oilLayer{
  display: flex;
}
.oilLayer div{
  height: 36px;
  width: 100px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  border-right: 1px solid rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box
}
.print{
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align:middle;
  position: absolute;
  top: 40px;
  left: 275px;
}
.exportExcel{
  position: absolute;
  top: 40px;
  left: 350px;
}
.icon{
  vertical-align:middle;
  margin-top: -4px
}
.oilItemsmall{
  width: 125px;
  height: 75px;
  margin-right: 10px;
  margin-left: 3px;
  margin-top: 10px;
  margin-bottom: 3px
}
.oilItemsmall .el-checkbox{
  position: absolute;
  left: 5px;
  top: 5px;
  line-height: 0
}
.oilTempBox{
  width: 743px !important;
}
.oilTempBox .dialog-setWrap{
  flex-direction: column;
  padding-right: 0px
}
.previewInfo{
  padding: 10px 0px 20px 10px;
  text-align: end
}
.oilImgsmall{
  height: 41px;
  width:33px;
  background-image: url("../../assets/grain/checkSquatSilo.png");
  background-size: cover;
  position: absolute;
  bottom: -42px;
  left: 75px;
}
.oilItemsmall .is-checked .oilImgsmall{
  background-image: url("../../assets/ware/squatSilo.png");
}
.updateCjTime{
  font-size: 14px;
  font-weight: 600;
  color: rgba(0,0,0,0.5);
  position: absolute;
  top: 15px
}
.oilCard{
  border: 1px solid rgba(0,0,0,0.1);
  width: 200px;
  position: absolute;
  right: 0;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0,0,0,.5)
}
.oilCardItem{
  border-bottom: 1px solid rgba(0,0,0,0.1);
  display: flex;
}
.oilCardItem:first-child{
  height: 30px;
  line-height: 30px;
  justify-content: center;
  background-color: rgba(48,56,255,0.03);
  color: #000
}
.oilCardItem:last-child{
  border:none;
}
.oilCardItem span{
  display: inline-block;
}
.oilCardTitle{
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-right: 1px solid rgba(0,0,0,0.1)
}
.oilCardWrap{
  width: 139px;
  height: 30px;
  line-height:30px;
  color: rgba(0,0,0,.8);
  padding-left: 10px;
  box-sizing: border-box
}
</style>
